import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-21v2',
  templateUrl: './21v2.component.html',
})
export class VbGeneral21v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
